module.exports = __webpack_public_path__ + "img/img_throw_4@3x_v3.8bfa3eb7.png";